export default {"src":"/manage-assets/_next/static/media/create-promo-light.5fa29a34.svg","height":175,"width":263,"blurWidth":0,"blurHeight":0};